import React from 'react';
import { Button, AvailableIcons } from 'src/components-dummy';
import { CreateExperimentFormProps } from './types';
import { useCreateExperimentForm } from './useCreateExperimentForm';
import './CreateExperimentForm.scss';

export const CreateExperimentForm = ({
  shopId,
  dispatch,
  editExperimentFormRoute,
}: CreateExperimentFormProps): JSX.Element => {
  const { onCreateDirect } = useCreateExperimentForm({
    shopId,
    dispatch,
    editExperimentFormRoute,
  });

  return (
    <div className='syte-create-experiment-form'>
      <Button
        startIcon={AvailableIcons.Add}
        variant='secondary'
        className='create-experiment-button'
        onClick={onCreateDirect}
      >
        Create Experiment
      </Button>
    </div>
  );
};
